import React, {useContext} from "react";
import {ContentContext} from "../ContentContext";

function DataProtection() {
    const data = useContext(ContentContext);

    return (
        <section className={"data-protection"}>
            <div dangerouslySetInnerHTML={{__html: data?.dataProtectionContent}} />
        </section>
    );
}

export default DataProtection;
